import { createAggregatedClient } from "@smithy/smithy-client";
import { CreateAnomalyMonitorCommand, } from "./commands/CreateAnomalyMonitorCommand";
import { CreateAnomalySubscriptionCommand, } from "./commands/CreateAnomalySubscriptionCommand";
import { CreateCostCategoryDefinitionCommand, } from "./commands/CreateCostCategoryDefinitionCommand";
import { DeleteAnomalyMonitorCommand, } from "./commands/DeleteAnomalyMonitorCommand";
import { DeleteAnomalySubscriptionCommand, } from "./commands/DeleteAnomalySubscriptionCommand";
import { DeleteCostCategoryDefinitionCommand, } from "./commands/DeleteCostCategoryDefinitionCommand";
import { DescribeCostCategoryDefinitionCommand, } from "./commands/DescribeCostCategoryDefinitionCommand";
import { GetAnomaliesCommand, } from "./commands/GetAnomaliesCommand";
import { GetAnomalyMonitorsCommand, } from "./commands/GetAnomalyMonitorsCommand";
import { GetAnomalySubscriptionsCommand, } from "./commands/GetAnomalySubscriptionsCommand";
import { GetApproximateUsageRecordsCommand, } from "./commands/GetApproximateUsageRecordsCommand";
import { GetCommitmentPurchaseAnalysisCommand, } from "./commands/GetCommitmentPurchaseAnalysisCommand";
import { GetCostAndUsageCommand, } from "./commands/GetCostAndUsageCommand";
import { GetCostAndUsageWithResourcesCommand, } from "./commands/GetCostAndUsageWithResourcesCommand";
import { GetCostCategoriesCommand, } from "./commands/GetCostCategoriesCommand";
import { GetCostForecastCommand, } from "./commands/GetCostForecastCommand";
import { GetDimensionValuesCommand, } from "./commands/GetDimensionValuesCommand";
import { GetReservationCoverageCommand, } from "./commands/GetReservationCoverageCommand";
import { GetReservationPurchaseRecommendationCommand, } from "./commands/GetReservationPurchaseRecommendationCommand";
import { GetReservationUtilizationCommand, } from "./commands/GetReservationUtilizationCommand";
import { GetRightsizingRecommendationCommand, } from "./commands/GetRightsizingRecommendationCommand";
import { GetSavingsPlanPurchaseRecommendationDetailsCommand, } from "./commands/GetSavingsPlanPurchaseRecommendationDetailsCommand";
import { GetSavingsPlansCoverageCommand, } from "./commands/GetSavingsPlansCoverageCommand";
import { GetSavingsPlansPurchaseRecommendationCommand, } from "./commands/GetSavingsPlansPurchaseRecommendationCommand";
import { GetSavingsPlansUtilizationCommand, } from "./commands/GetSavingsPlansUtilizationCommand";
import { GetSavingsPlansUtilizationDetailsCommand, } from "./commands/GetSavingsPlansUtilizationDetailsCommand";
import { GetTagsCommand } from "./commands/GetTagsCommand";
import { GetUsageForecastCommand, } from "./commands/GetUsageForecastCommand";
import { ListCommitmentPurchaseAnalysesCommand, } from "./commands/ListCommitmentPurchaseAnalysesCommand";
import { ListCostAllocationTagBackfillHistoryCommand, } from "./commands/ListCostAllocationTagBackfillHistoryCommand";
import { ListCostAllocationTagsCommand, } from "./commands/ListCostAllocationTagsCommand";
import { ListCostCategoryDefinitionsCommand, } from "./commands/ListCostCategoryDefinitionsCommand";
import { ListSavingsPlansPurchaseRecommendationGenerationCommand, } from "./commands/ListSavingsPlansPurchaseRecommendationGenerationCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { ProvideAnomalyFeedbackCommand, } from "./commands/ProvideAnomalyFeedbackCommand";
import { StartCommitmentPurchaseAnalysisCommand, } from "./commands/StartCommitmentPurchaseAnalysisCommand";
import { StartCostAllocationTagBackfillCommand, } from "./commands/StartCostAllocationTagBackfillCommand";
import { StartSavingsPlansPurchaseRecommendationGenerationCommand, } from "./commands/StartSavingsPlansPurchaseRecommendationGenerationCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UpdateAnomalyMonitorCommand, } from "./commands/UpdateAnomalyMonitorCommand";
import { UpdateAnomalySubscriptionCommand, } from "./commands/UpdateAnomalySubscriptionCommand";
import { UpdateCostAllocationTagsStatusCommand, } from "./commands/UpdateCostAllocationTagsStatusCommand";
import { UpdateCostCategoryDefinitionCommand, } from "./commands/UpdateCostCategoryDefinitionCommand";
import { CostExplorerClient } from "./CostExplorerClient";
const commands = {
    CreateAnomalyMonitorCommand,
    CreateAnomalySubscriptionCommand,
    CreateCostCategoryDefinitionCommand,
    DeleteAnomalyMonitorCommand,
    DeleteAnomalySubscriptionCommand,
    DeleteCostCategoryDefinitionCommand,
    DescribeCostCategoryDefinitionCommand,
    GetAnomaliesCommand,
    GetAnomalyMonitorsCommand,
    GetAnomalySubscriptionsCommand,
    GetApproximateUsageRecordsCommand,
    GetCommitmentPurchaseAnalysisCommand,
    GetCostAndUsageCommand,
    GetCostAndUsageWithResourcesCommand,
    GetCostCategoriesCommand,
    GetCostForecastCommand,
    GetDimensionValuesCommand,
    GetReservationCoverageCommand,
    GetReservationPurchaseRecommendationCommand,
    GetReservationUtilizationCommand,
    GetRightsizingRecommendationCommand,
    GetSavingsPlanPurchaseRecommendationDetailsCommand,
    GetSavingsPlansCoverageCommand,
    GetSavingsPlansPurchaseRecommendationCommand,
    GetSavingsPlansUtilizationCommand,
    GetSavingsPlansUtilizationDetailsCommand,
    GetTagsCommand,
    GetUsageForecastCommand,
    ListCommitmentPurchaseAnalysesCommand,
    ListCostAllocationTagBackfillHistoryCommand,
    ListCostAllocationTagsCommand,
    ListCostCategoryDefinitionsCommand,
    ListSavingsPlansPurchaseRecommendationGenerationCommand,
    ListTagsForResourceCommand,
    ProvideAnomalyFeedbackCommand,
    StartCommitmentPurchaseAnalysisCommand,
    StartCostAllocationTagBackfillCommand,
    StartSavingsPlansPurchaseRecommendationGenerationCommand,
    TagResourceCommand,
    UntagResourceCommand,
    UpdateAnomalyMonitorCommand,
    UpdateAnomalySubscriptionCommand,
    UpdateCostAllocationTagsStatusCommand,
    UpdateCostCategoryDefinitionCommand,
};
export class CostExplorer extends CostExplorerClient {
}
createAggregatedClient(commands, CostExplorer);
